import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import { handleHTTPError, putSystemSettings, putUser, showMessage } from 'store/actions';
import RouteApp from './Route';
import toast from 'cogo-toast';
import Login from './Auth/login';
import ForgotPass from './Auth/ForgotPass';
import ResetPass from './Auth/ResetPass';
import { fetchMe, getSystemSettings } from 'apis';

const RestrictedRoute = ({ component: Component, authUser, ...rest }) => (
    <Route
        {...rest}
        render={(props) =>
            authUser ? (
                <Component {...props} />
            ) : (
                <Redirect
                    to={{
                        pathname: '/signin',
                        state: { from: props.location },
                    }}
                />
            )
        }
    />
);

class Container extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showMsg: false,
        };
    }

    componentDidMount = () => {
        this.initApp();
    };

    componentDidUpdate = (prevProps) => {
        if (!prevProps.showMsg && this.props.showMsg) this.showMessage();
        if (!prevProps.accessToken && this.props.accessToken) {
            this.initApp();
        }
    };

    initApp = async () => {
        try {
            const { data: sysSetting } = await getSystemSettings();
            console.log(sysSetting);
            this.props.putSystemSettings(sysSetting);
            if (this.props.accessToken) {
                const { data } = await fetchMe();
                this.props.putUser(data);
            }
        } catch (error) {
            this.props.handleHTTPError(error);
        }
    };

    showMessage = () => {
        if (this.props.message !== null) {
            if (this.props.message.type === 'success') {
                return toast
                    .success(this.props.message.text, { position: 'top-right', heading: 'Success' })
                    .then(() => {
                        this.props.showMessage({ showMsg: false, message: null });
                    });
            } else if (this.props.message.type === 'warning') {
                return toast.warn(this.props.message.text, { position: 'top-right', heading: 'Warning' }).then(() => {
                    this.props.showMessage({ showMsg: false, message: null });
                });
            } else {
                return toast.error(this.props.message.text, { position: 'top-right', heading: 'Error' }).then(() => {
                    this.props.showMessage({ showMsg: false, message: null });
                });
            }
        }
    };

    render() {
        const { match, accessToken, systemSettings } = this.props;

        if (!systemSettings) return null;

        return (
            <Switch>
                <Route path="/signin" component={Login} />
                <Route path="/forgotpass" component={ForgotPass} />
                <Route path="/resetpass" component={ResetPass} />
                <RestrictedRoute path={`${match.url}`} authUser={accessToken} component={RouteApp} />
            </Switch>
        );
    }
}

const mapStateToProps = ({ user, ui }) => {
    const { systemSettings, accessToken } = user;
    const { showMsg, message } = ui;
    return { showMsg, message, systemSettings, accessToken };
};

export default connect(mapStateToProps, {
    showMessage,
    putSystemSettings,
    handleHTTPError,
    putUser,
})(Container);
